import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentMileMultiSelectComponent implements IController {
  fulfillmentMiles: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor(private FulfillmentConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.FulfillmentConstants.fulfillmentMiles;
    }
  }

  $onChanges(changes) {
    if (changes.fulfillmentMiles) {
      this.selectedKeys = [];
      _.forEach(this.fulfillmentMiles, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      fulfillmentMiles: isSelected ? _.concat(this.fulfillmentMiles, [option]) :
        _.filter(this.fulfillmentMiles, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({fulfillmentMiles: []});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentMileMultiSelectList', {
    bindings: {
      fulfillmentMiles: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./fulfillment-mile-multi-select.html').default,
    controller: FulfillmentMileMultiSelectComponent
  });


